import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import { darkTextBoxBackgroundColour, featureTileYellow } from "theme";
import title from "assets/images/homePage/nextGenSection/title_freeupgrade.png";
import Spacer from "components/Spacer";
import SkewedSection from "components/SkewedSection";
import routes from "routes";
import RouterLink from "components/links/RouterLink";

const useStyles = (isMobile: boolean) =>
    makeStyles((theme: Theme) => {
        const imageMarginTop = isMobile ? 0 : theme.spacing(6);

        return createStyles({
            root: {
                backgroundColor: darkTextBoxBackgroundColour,
                color: featureTileYellow,
                padding: theme.spacing(3),
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: imageMarginTop,
            },
            image: {
                marginTop: -imageMarginTop,
                maxWidth: 500,
                width: "100%",
            },
            text: {
                lineHeight: 1.35,
                textAlign: "center",
                maxWidth: 600,
            },
        });
    });

interface IProps extends HTMLAttributes<HTMLDivElement> {
    isMobile?: boolean;
}

export default function NextGenUpgradeTextBox(props: IProps) {
    const { isMobile = false, className, ...rest } = props;
    const classes = useStyles(isMobile)();

    const content = (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img className={classes.image} src={title} alt="" />
            </div>
            {isMobile ? <Spacer /> : null}
            
            <Typography className={classes.text}>
                *Discless consoles require a digital entitlement to upgrade.
            </Typography>

            <Spacer size={2} />

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textTransform: "uppercase",
                }}
            >
                <Typography>
                    See{" "}
                    <RouterLink
                        to={`${routes.news.route}/dirt-5-free-next-gen-upgrade`}
                        underline="always"
                    >
                        News
                    </RouterLink>{" "}
                    for details
                </Typography>
            </div>
        </>
    );

    return isMobile ? (
        <SkewedSection axis="y" className={clsx(className, classes.root)} {...rest}>
            {content}
        </SkewedSection>
    ) : (
        <div className={clsx(className, classes.root)} {...rest}>
            {content}
        </div>
    );
}
